"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredPcbLayoutRuleSetSchema = exports.StoredPcbLayoutRuleSchema = void 0;
const zod_1 = require("zod");
const structure_1 = require("./structure");
/*
 * Schemas for storing pcb objects in Firestore.  For the most part, pcb layout nodes and rules
 * are stored in the database precisely as they are in memory - with one big exception.
 *
 * We _explicitly_ do not store baked or flattened rules in the database, and the schemas are defined
 * as such.  This is because the baked and flattened rules are in-memory values only - they should not
 * be passed out of the client and used in another context.
 */
/**
 * Pcb layout nodes have rules attached to them.
 */
exports.StoredPcbLayoutRuleSchema = zod_1.z.object({
    uid: zod_1.z.string(),
    userCodeData: zod_1.z.optional(zod_1.z.any()),
    key: zod_1.z.enum(structure_1.ruleKeys),
    value: zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.undefined()]),
    payloadAsBase64: zod_1.z.optional(zod_1.z.string()),
    payloadFileName: zod_1.z.optional(zod_1.z.string()),
    order: zod_1.z.optional(zod_1.z.number()),
    disabled: zod_1.z.optional(zod_1.z.boolean()),
    referenceOfDocumentUid: zod_1.z.optional(zod_1.z.string()),
});
/**
 * Rules are grouped together into "rule sets".
 */
exports.StoredPcbLayoutRuleSetSchema = zod_1.z.object({
    uid: zod_1.z.string(),
    rules: zod_1.z.record(zod_1.z.string(), exports.StoredPcbLayoutRuleSchema),
    disabled: zod_1.z.optional(zod_1.z.boolean()),
    selector: zod_1.z.string(),
    name: zod_1.z.optional(zod_1.z.string()),
    description: zod_1.z.optional(zod_1.z.string()),
    referenceOfDocumentUid: zod_1.z.optional(zod_1.z.string()),
    inheritedFromAncestorNodeUid: zod_1.z.optional(zod_1.z.string()),
});
//# sourceMappingURL=schema.js.map